import { render, staticRenderFns } from "./addActuality.vue?vue&type=template&id=7619dc96&"
import script from "./addActuality.vue?vue&type=script&lang=js&"
export * from "./addActuality.vue?vue&type=script&lang=js&"
import style0 from "./addActuality.vue?vue&type=style&index=0&id=7619dc96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports